export class UserConfirmation {
  constructor(public password?: string,
              public passwordConfirmation?: string) {
  }
}
